import type { Seen } from "./http.ts";

export function createReloadOffer(touch: (topic: string) => void) {
  let offered = false;
  const offer = () => {
    offered = true;
    touch("reload");
  };
  return {
    offer,
    offered: () => offered,
    seen(info: Seen): void {
      if (info.versionMismatch && !offered) offer();
    },
  };
}
